
  import missions from '~/mixins/pages/mission-control/missions'
  export default {
    name: 'Theme2MissionDesktopRoadmapLayoutsTypeGuideline',
    mixins: [missions],
    props: {
      activitiesList: {
        type: Array,
        default: () => {}
      },
      missionId: {
        type: String,
        default: ''
      },
      loading: {
        type: Boolean,
        default: false
      },
      extraCoin: {
        type: Number,
        default: 0
      },
      extraCoinStatus: {
        type: Number,
        default: 0
      },
      missionActivitiesLoading: {
        type: Boolean,
        default: false
      } // This mission loading will be true only when the query string is changed
    }
  }
